/**
 * Company: SPHMedia
 * Description: [Brief description of the component]
 */

import Divider from "@assets/divider.svg?react";
import type { BFFArticleCard } from "@src/app/types/bff";
import type { ReactElement } from "react";

import Link from "../Link";

type NumberedCardProps = {
  // Define the type for the props required by the component (if any)
  article: BFFArticleCard;
  index: number;
  testId?: number | string;
};

/**
 * NumberedCard
 * Description: [Description of what the component does]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function NumberedCard(props: NumberedCardProps): ReactElement {
  return (
    <>
      <div
        data-testid={`numbered-card-${props.testId}`}
        className="flex gap-[8px] pb-[16px]"
      >
        <span className="flex size-[24px] shrink-0 items-center justify-center rounded-full bg-primary pb-[3px] text-center text-subheader text-primary-on-dark">
          {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            props.index ?? 1
          }
        </span>
        <Link to={`${props.article.urlPath}?ref=home-sidebar-most-clicked`}>
          <h3 className="line-clamp-3 text-header-3 text-primary lg:hover:underline">
            {props.article.title}
          </h3>
        </Link>
      </div>
      <Divider />
    </>
  );
}
